export default __webpack_public_path__ + "static/media/card.docs.2ff6975d.mdx";